export default class TeamFinanceSettings {
    public defaultCurrency: string = null;
    public defaultCountry: string = null;
}
